import React from 'react'

import { I_CasePost } from '../state/wpDataStore'

const CaseAttributes = ({
  casePost,
  inModal,
}: {
  casePost: I_CasePost
  inModal?: boolean
}) => {
  const { acf } = casePost

  return acf ? (
    <div
      className={['case-attributes', inModal && 'case-attributes--grid'].join(
        ' '
      )}
    >
      {[
        ['building_type', 'Building Type'],
        ['hvac_system_from', 'HVAC System'], // Gets merged with hvac_system_to (post object relation)
        ['fabric_system_changes', 'Fabric/System Changes'],
        ['floor_area', 'Floor Area'],
        ['country', 'Country'],
      ].map(([key, label]) => {
        if (acf[key] === undefined) return null

        let value = acf[key] ? String(acf[key]) : '-'

        // Special case to merge hvac_system_from and hvac_system_to
        if (key === 'hvac_system_from') {
          if (acf['hvac_system_from'] && acf['hvac_system_to']) {
            value = `
            <span>${String(acf['hvac_system_from'])}</span>
            <i class="fa-solid fa-arrow-right"></i>
            <span>${String(acf['hvac_system_to'].post_title)}</span>`
          } else {
            value = '-'
          }
        }

        return <AttributeItem key={key} label={label} value={value} />
      })}
    </div>
  ) : null
}

const AttributeItem = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className='case-attributes__item'>
      <p className='case-attributes__item-label'>{label}</p>
      <p
        className='case-attributes__item-value'
        dangerouslySetInnerHTML={{ __html: value }}
      />
    </div>
  )
}

export { CaseAttributes }
